import { queryOptions } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { ICompany } from 'views/DealDashboard/types';

const getCRMDealCompaniesQueryOptions = (organizationId: string, dealId: number) => queryOptions({
    queryKey: ['CRMDealCompanies', organizationId, dealId],
    queryFn: async () => {
        const response = await axiosInstance.get<ICompany[]>(
            API_ENDPOINTS.CRM.DEAL_COMPANIES(organizationId, dealId),
        );
        return response.data;
    },
});

export default getCRMDealCompaniesQueryOptions;
